<template>
  <div class="bidder-page">
    <!-- 提示信息 -->
    <div class="notice-section">
      <el-alert title="直接下载招标文件的项目无报名环节,无需在此查看,&quot;请点击左侧菜单——>我的购标项目/我参与的项目&quot;查看。" type="warning" :closable="false"
        show-icon>
      </el-alert>
    </div>
    <!-- 搜索区域 -->
    <div class="search-section">
      <el-form :model="searchForm" :inline="true" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.projectName" placeholder="招标项目或标段名称" clearable style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="projectName" label="项目名称" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.projectName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bidSectionName" label="标段名称" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.bidSectionName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bidSectionCode" label="标段编码" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.bidSectionCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="relationUser" label="投标联系人" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.relationUser || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="userPhone" label="电话" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.userPhone || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="220">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 9">
              已通过,请到"我的订单"进行支付,无标书款可直接前往"我的购标项目/我参与的项目"下载招标文件
            </template>
            <template v-else-if="scope.row.status == 3">
              退回{{ scope.row.reason ? '：' + scope.row.reason : '' }}
            </template>
            <template v-else-if="scope.row.status == 0">
              暂存
            </template>
            <template v-else-if="scope.row.status == 1">
              提交待审
            </template>
            <template v-else>
              -
            </template>
          </template>
        </el-table-column>
        <!-- 其它列可继续按需配置 -->
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handlePurchase(scope.row)">
              <template v-if="scope.row.status == 3">修改</template>
              <template v-else>详情</template>
            </el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>



    <!-- 购标弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="purchaseDialogVisible" width="85%" :append-to-body="true"
      class="purchase-dialog" :before-close="handleDialogClose">
      <div class="purchase-content">
        <!-- 项目信息展示区域 -->
        <div class="project-info-section" v-if="currentProject">
          <div class="section-title">
            <i class="el-icon-info"></i>
            项目信息
          </div>
          <div class="project-info-grid">
            <div class="info-item">
              <label>项目名称：</label>
              <span>{{ currentProject.projectName }}</span>
            </div>
            <div class="info-item">
              <label>标段名称：</label>
              <span>{{ currentProject.sectionName }}</span>
            </div>
            <div class="info-item">
              <label>标段编码：</label>
              <span>{{ currentProject.sectionCode }}</span>
            </div>
            <div class="info-item">
              <label>当前状态：</label>
              <el-tag :type="getStatusType(currentProject.status)" size="small">
                {{ getStatusText(currentProject.status) }}
              </el-tag>
            </div>
          </div>
        </div>

        <!-- 投标人信息 -->
        <div class="bidder-info-section">
          <div class="section-title">
            <i class="el-icon-user"></i>
            投标人信息
          </div>
          <div class="form-grid">
            <!-- 左列 -->
            <div class="form-column">
              <div class="form-item">
                <label>投标单位：</label>
                <el-input v-model="purchaseForm.bidder" placeholder="请输入投标单位" :disabled="isReadOnly"></el-input>
              </div>
              <div class="form-item required">
                <label><span class="required-mark">*</span>投标联系人：</label>
                <el-input v-model="purchaseForm.contactPerson" placeholder="请输入投标联系人" :disabled="isReadOnly"></el-input>
              </div>
              <div class="form-item required">
                <label><span class="required-mark">*</span>邮箱：</label>
                <el-input v-model="purchaseForm.email" placeholder="请输入邮箱" :disabled="isReadOnly"></el-input>
              </div>
            </div>
            <!-- 右列 -->
            <div class="form-column">
              <div class="form-item required">
                <label><span class="required-mark">*</span>手机号：</label>
                <el-input v-model="purchaseForm.mobile" placeholder="请输入手机号" :disabled="isReadOnly"></el-input>
              </div>
              <!-- <div class="form-item">
                <label>固定电话：</label>
                <el-input v-model="purchaseForm.phone" placeholder="请输入固定电话" :disabled="isReadOnly"></el-input>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 报名资料说明 -->
        <div class="registration-info-section">
          <div class="section-title">
            <i class="el-icon-document"></i>
            报名资料说明
          </div>
          <div class="description-textarea">
            <el-input v-model="purchaseForm.bidderQualification" type="textarea" :rows="4" placeholder="请输入报名资料说明..."
              :disabled="isReadOnly">
            </el-input>
          </div>
        </div>

        <!-- 上传报名资料 -->
        <div class="upload-section">
          <div class="section-title">
            <i class="el-icon-upload"></i>
            上传报名资料
          </div>
          <div class="upload-table">
            <el-table :data="uploadFiles" border style="width: 100%"
              :header-cell-style="{ background: '#fafafa', color: '#333', fontWeight: '600' }">
              <el-table-column prop="fileName" label="资料名称" min-width="200">
                <template slot-scope="scope">
                  <div class="file-name">
                    <i class="el-icon-document"></i>
                    {{ scope.row.fileName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="说明" min-width="150"></el-table-column>
              <el-table-column prop="uploadedFileName" label="已上传文件" min-width="180">
                <template slot-scope="scope">
                  <span v-if="hasUploadedFile(scope.row)" class="file-name">
                    <i class="el-icon-paperclip"></i>
                    {{ scope.row.uploadedFileName || '已上传文件' }}
                  </span>
                  <span v-else class="no-file">未上传</span>
                </template>
              </el-table-column>
              <el-table-column prop="preview" label="预览" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-button v-if="hasUploadedFile(scope.row)" type="text" size="small" icon="el-icon-view"
                    @click="handlePreview(scope.row)">
                    预览
                  </el-button>
                  <span v-else class="no-file">-</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="120" align="center" v-if="!isReadOnly">
                <template slot-scope="scope">
                  <el-button type="text" size="small" icon="el-icon-upload2"
                    :loading="scope.row.uploading"
                    @click="handleUploadDocument(scope.row)">
                    上传
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="footer-left">
          <el-button @click="handleCancelPurchase" icon="el-icon-close">取消</el-button>
        </div>
        <div class="footer-right">
          <el-button v-if="!isReadOnly" type="primary" @click="handlePlaceOrder" icon="el-icon-check"
            :loading="submitting">
            {{ submitting ? '提交中...' : '确定' }}
          </el-button>
          <el-button v-if="isReadOnly" type="primary" @click="handleCancelPurchase" icon="el-icon-check">
            关闭
          </el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import { getRegisterList, getRegisterInfo, addRegister } from '@/api/tenderNotice/api'
import { getFileList } from '@/api/base/api'
import { doFileUpload } from '@/utils/fileUploadHelper'

const createDefaultPurchaseForm = () => ({
  bidder: '',
  bidderQualification: '',
  contactPerson: '',
  phone: '',
  email: '',
  mobile: ''
})

export default {
  name: 'RegistrationStatus',
  data() {
    return {
      searchForm: {
        projectName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      purchaseDialogVisible: false,
      currentProject: null,
      isReadOnly: false,
      submitting: false,
      dialogTitle: '标段（包）信息',
      uploadAction: '/api/upload',
      purchaseForm: createDefaultPurchaseForm(),
      uploadFiles: []
    }
  },
  mounted() {
    this.loadRegisterList()
  },
  methods: {
    hasUploadedFile(row) {
      return !!(row && row.uploadFileId)
    },

    loadRegisterList() {
      getRegisterList({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        projectName: this.searchForm.projectName || ''
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
          if (res.data.current) {
            this.currentPage = res.data.current
          }
          if (res.data.size) {
            this.pageSize = res.data.size
          }
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error(res.msg || '加载报名列表失败')
        }
      }).catch(err => {
        this.tableData = []
        this.total = 0
        this.$message.error('加载报名列表失败')
      })
    },

    handleSearch() {
      this.currentPage = 1
      this.loadRegisterList()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadRegisterList()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.loadRegisterList()
    },

    handlePurchase(row) {
      this.currentProject = { ...row }
      if (row.status === 3) {
        this.isReadOnly = false
        this.dialogTitle = '修改报名信息'
      } else {
        this.isReadOnly = true
        this.dialogTitle = '查看报名详情'
      }
      this.apiGetRegisterInfo(row)
      this.purchaseDialogVisible = true
    },

    apiGetRegisterInfo(row) {
      getRegisterInfo({
        bidSectionCode: row.bidSectionCode
      }).then(res => {
        if (res.code === 200) {
          const data = res.data || {}
          this.currentProject = {
            projectName: data.bidRegistration.projectName || '',
            sectionName: data.bidRegistration.bidSectionName || '',
            sectionCode: data.bidRegistration.bidSectionCode || '',
            status: data.bidRegistration.status

          }

          this.purchaseForm = {
            ...createDefaultPurchaseForm(),
            bidderQualification: data.bidRegistration.bidderQualification || '',
            contactPerson: data.bidRegistration.relationUser || '',
            email: data.bidRegistration.email || '',
            mobile: data.bidRegistration.userPhone || '',
            phone: data.bidRegistration.userTel || ''
          }
          const files = Array.isArray(data.registrationFiles) ? data.registrationFiles : []
          this.uploadFiles = files.map(item => ({
            fileName: item.registrationName || '',
            description: item.registrationDescription || '',
            uploadedFileName: item.fileName || '',
            fileUrl: item.filePath || '',
            uploadFileId: item.uploadFileId,
            registrationGuid: item.registrationGuid || '',
            fileGuid: item.uploadFileId || item.fileGuid || ''

          }))
        }
      })
    },

    getStatusType(status) {
      const statusMap = {
        9: 'success',
        3: 'danger',
        1: 'warning',
        0: 'info'
      }
      return statusMap[status] || 'info'
    },

    getStatusText(status) {
      const statusMap = {
        9: '已通过',
        3: '退回',
        1: '提交待审',
        0: '暂存'
      }
      return statusMap[status] || '待审核'
    },

    handleUploadDocument(row) {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.pdf,.doc,.docx,.jpg,.jpeg,.png'
      input.onchange = (event) => {
        this.handleFileSelect(event, row)
      }
      input.click()
    },

    validateFile(file) {
      const maxSize = 102400 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10GB')
        return false
      }
      const allowedTypes = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
      if (!allowedTypes.includes(fileExtension)) {
        this.$message.error('不支持的文件类型')
        return false
      }
      return true
    },

    async handleFileSelect(event, row) {
      const rawFile = event.target.files[0]
      if (!rawFile || !this.validateFile(rawFile)) {
        return
      }
      const index = this.uploadFiles.findIndex(file => file.registrationGuid === row.registrationGuid)
      if (index < 0 || index >= this.uploadFiles.length || !this.uploadFiles[index]) {
        this.$message.error('上传失败：文件索引无效')
        return
      }
      this.$set(this.uploadFiles[index], 'uploading', true)
      try {
        const fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
        this.$set(this.uploadFiles[index], 'fileGuid', fileBindId)
        let uploadedFileId = ''
        const result = await doFileUpload(rawFile, {
          fileBindId: fileBindId,
          onSuccess: (r) => {
            uploadedFileId = r.fileId || r.id || r.uploadFileId || ''
          },
          onError: () => {}
        })
        if (!result || !result.success) {
          this.$message.error((result && result.message) || '文件上传失败')
          return
        }
        const fileId = uploadedFileId || result.fileId || result.uploadFileId || result.fileGuid || ''
        this.$set(this.uploadFiles[index], 'uploadedFileName', rawFile.name)
        this.$set(this.uploadFiles[index], 'fileName', rawFile.name)
        this.$set(this.uploadFiles[index], 'fileUrl', result.filePath || '')
        this.$set(this.uploadFiles[index], 'uploadFileId', fileId)
        this.$set(this.uploadFiles[index], 'fileGuid', fileBindId)
        if (result.registrationGuid) {
          this.$set(this.uploadFiles[index], 'registrationGuid', result.registrationGuid)
        }
        this.$message.success('文件上传成功!')
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error((error && error.message) || '文件上传失败')
      } finally {
        this.$set(this.uploadFiles[index], 'uploading', false)
      }
    },
    async handlePreview(row) {
      if (!this.hasUploadedFile(row)) {
        return
      }
      try {
        const res = await getFileList(row.uploadFileId)
        if (res.code === 200 && Array.isArray(res.data) && res.data.length > 0) {
          const firstFile = res.data[0]
          if (firstFile.fileUrl) {
            window.open(firstFile.fileUrl, '_blank')
            return
          }
          this.$message.warning('文件链接不存在')
          return
        }
        this.$message.error(res.msg || '获取文件列表失败')
      } catch (error) {
        console.error('获取文件列表失败:', error)
        this.$message.error('获取文件列表失败')
      }
    },

    handleDialogClose(done) {
      if (this.submitting) {
        this.$message.warning('正在提交中，请稍候...')
        return
      }

      if (!this.isReadOnly && this.hasUnsavedChanges()) {
        this.$confirm('确定要关闭吗？未保存的修改将丢失。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.resetForm()
          done()
        }).catch(() => {})
      } else {
        this.resetForm()
        done()
      }
    },

    hasUnsavedChanges() {
      return this.purchaseForm.contactPerson ||
        this.purchaseForm.email ||
        this.purchaseForm.mobile ||
        this.uploadFiles.some(file => this.hasUploadedFile(file))
    },

    resetForm() {
      this.purchaseForm = createDefaultPurchaseForm()
      this.uploadFiles = []
      this.currentProject = null
      this.isReadOnly = false
      this.submitting = false
    },

    handleCancelPurchase() {
      this.purchaseDialogVisible = false
    },

    async handlePlaceOrder() {
      if (!this.validateForm()) {
        return
      }
      if (!this.currentProject || !this.currentProject.sectionCode) {
        this.$message.error('标段信息丢失，请重新选择')
        return
      }
      const requestData = this.buildRegistrationRequestData(1)
      try {
        this.submitting = true
        const response = await addRegister(requestData)
        if (response.code === 200) {
          this.$message.success('报名信息提交成功！')
          this.purchaseDialogVisible = false
          this.resetForm()
          this.loadRegisterList()
        } else {
          this.$message.error(response.msg || '提交失败')
        }
      } catch (error) {
        console.error('提交报名信息失败:', error)
        this.$message.error('提交失败，请重试')
      } finally {
        this.submitting = false
      }
    },

    buildRegistrationRequestData(status) {
      return {
        id: null,
        status: status,
        bidRegistration: {
          bidSectionCode: this.currentProject.sectionCode,
          bidderQualification: this.purchaseForm.bidderQualification,
          relationUser: this.purchaseForm.contactPerson,
          userTel: this.purchaseForm.phone,
          userPhone: this.purchaseForm.mobile,
          email: this.purchaseForm.email
        },
        registrationFiles: this.uploadFiles.map(file => ({
          registrationGuid: file.registrationGuid,
          uploadFileId: file.fileGuid || file.uploadFileId,
          fileGuid: file.fileGuid || file.uploadFileId
        }))
      }
    },

    validateForm() {
      if (!this.purchaseForm.contactPerson) {
        this.$message.error('请输入投标联系人!')
        return false
      }
      if (!this.purchaseForm.email) {
        this.$message.error('请输入邮箱!')
        return false
      }
      if (!this.purchaseForm.mobile) {
        this.$message.error('请输入手机号!')
        return false
      }

      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailReg.test(this.purchaseForm.email)) {
        this.$message.error('请输入正确的邮箱格式!')
        return false
      }

      const mobileReg = /^1[3-9]\d{9}$/
      if (!mobileReg.test(this.purchaseForm.mobile)) {
        this.$message.error('请输入正确的手机号格式!')
        return false
      }

      return true
    }

  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-page {
  .apply-minimal-gray-theme();
}

/* 提示信息区域 */
.notice-section {
  margin-bottom: 20px;

  /deep/ .el-alert {
    border-radius: 4px;
    border-left: 3px solid @warning-color;
  }
}

/* 状态列样式 */
/deep/ .el-table .cell {
  white-space: pre-line;
  line-height: 1.6;
}



/* 弹窗样式 */
.purchase-dialog {
  /deep/ .el-dialog__header {
    background: @gray-50;
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
  }

  /deep/ .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: @gray-800;
  }

  /deep/ .el-dialog__body {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;
    background: @gray-50;
  }

  /deep/ .el-dialog__footer {
    padding: 0;
    border-top: 1px solid @gray-200;
  }
}

.purchase-content {
  padding: 0;
}

/* 项目信息区域 */
.project-info-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.project-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
}

.info-item {
  display: flex;
  align-items: center;

  label {
    font-weight: 600;
    color: @gray-700;
    margin-right: 12px;
    min-width: 90px;
  }

  span {
    color: @gray-800;
  }
}

/* 投标人信息区域 */
.bidder-info-section,
.registration-info-section,
.upload-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 16px;
}

.form-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-item {
  display: flex;
  align-items: center;

  &.required label {
    color: @gray-800;
  }

  label {
    min-width: 120px;
    font-size: 14px;
    color: @gray-700;
    margin-right: 12px;
    flex-shrink: 0;
  }

  /deep/ .el-input {
    flex: 1;
  }
}

.required-mark {
  color: @error-color;
  margin-right: 4px;
}

/* 报名资料说明 */
.description-textarea {
  margin-top: 16px;

  /deep/ .el-textarea__inner {
    resize: vertical;
    min-height: 100px;
    border-color: @gray-300;

    &:focus {
      border-color: @primary-color;
    }
  }
}

/* 上传区域 */
.upload-table {
  margin-top: 16px;
}

.file-name {
  display: flex;
  align-items: center;
  color: @primary-color;

  i {
    margin-right: 6px;
  }
}

.no-file {
  color: @gray-400;
  font-style: italic;
}

/* 区域标题 */
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: @gray-800;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid @primary-color;
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 20px;
    background: @primary-color;
    border-radius: 2px;
  }

  i {
    margin-right: 8px;
    color: @primary-color;
  }
}

/* 弹窗底部 */
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #fff;

  .footer-left,
  .footer-right {
    display: flex;
    gap: 12px;
  }

  /deep/ .el-button {
    min-width: 100px;
    transition: all @transition-base ease;

    &:hover {
      transform: translateY(-1px);
    }
  }
}
</style>
